import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import { FilterPopover as CoreFilterPopover } from "@b2bportal/core-ui";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Button, ButtonTypeEnum, Icon } from "@tenant/ui";
import clsx from "clsx";
import styles from "./styles.module.scss";

type FilterPopoverProps = React.ComponentProps<typeof CoreFilterPopover> & {
  onReset?: () => void;
};
const COMPONENT_KEY = CoreUiComponents.FilterPopover;
export const FilterPopover = ({
  onReset,
  ...restProps
}: FilterPopoverProps) => {
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const { className, isApplied } = restProps;

  return (
    <div className={clsx(block, className)}>
      <CoreFilterPopover {...restProps} disablePortal={true} />
      {onReset != null && isApplied != null && isApplied ? (
        <Button
          buttonType={ButtonTypeEnum.Wrap}
          onClick={onReset}
          className={cn("reset-button")}
          aria-label={t("searchFilter.resetFilters")}
        >
          <Icon className={cn("clear-filter")} iconName={IconNameEnum.close} />
        </Button>
      ) : null}
    </div>
  );
};
